<template>
  <div v-if="initCompleted">
    <div id="stickyline"></div>

    <main class="container-fixed offset-top-1 offset-bottom-2">
      <img src="@/assets/images/cita/logo-zahl-einfach60.png" width="176" height="60" :alt="$t('cita.logoAlt')" />
      <hr class="offset-top-1 offset-bottom-1" />

      <slot />
    </main>

    <VFooter disable-logo-link>
      <template #prepend>
        <li>
          <a :href="authSiteUrl" target="_blank">{{ $t('cita.footerBarringLink') }}</a>
        </li>
      </template>
      <template #append>
        <li>
          <router-link :to="{ name: CITA_HELP, query: { sessionId } }" target="_blank">{{ $t('cita.help_headline') }}</router-link>
        </li>
      </template>
    </VFooter>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { AUTH, CITA_HELP } from '@route-types';

export default {
  name: 'LayoutCita',

  components: {
    VFooter: () => import('@/components/UI/Footer'),
  },

  data() {
    return {
      AUTH,
      CITA_HELP,
    };
  },

  computed: {
    ...mapState('cita', ['initCompleted', 'authSiteUrl']),
    ...mapState('system', ['sessionId']),
  },

  async created() {
    await this.init();
  },

  methods: {
    ...mapActions('cita', ['init']),
  },
};
</script>
